import { useState, useEffect, useRef } from 'react';
import './login.css';
import Panneladmin from '../panneladmin/Panneladmin';

export default function LoginPage() {
    const [password, setPassword] = useState('');
    const [login, setLogin] = useState(false);
    const [captchaValue, setCaptchaValue] = useState('');
    const [userCaptchaInput, setUserCaptchaInput] = useState('');
    const captchaCanvasRef = useRef(null);

    // تولید یک عدد تصادفی 5 رقمی
    const generateCaptcha = () => {
        const randomNumber = Math.floor(10000 + Math.random() * 90000).toString();
        setCaptchaValue(randomNumber);
        return randomNumber;
    };

    useEffect(() => {
        const canvas = captchaCanvasRef.current;
        const context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);
    
        // تنظیمات کلی فونت و پس‌زمینه
        context.font = 'bold 28px Arial';
        context.fillStyle = '#f0f0f0';
        context.fillRect(0, 0, canvas.width, canvas.height);
    
        // تولید یک عدد تصادفی 5 رقمی
        const captchaText = generateCaptcha();
    
        // تنظیم فاصله دقیق برای نمایش کامل هر رقم
        const startX = 15;  // فاصله شروع برای اولین رقم
        const letterSpacing = 20; // فاصله بین ارقام
    
        for (let i = 0; i < captchaText.length; i++) {
            const char = captchaText[i];
    
            // موقعیت دقیق برای هر رقم و محدود کردن چرخش
            const x = startX + i * letterSpacing;
            const y = 35; // موقعیت عمودی ثابت برای وضوح بیشتر
            const rotation = (Math.random() * 0.1 - 0.05); // چرخش محدود در بازه‌ی کم
    
            // رسم رقم با موقعیت دقیق و چرخش محدود
            context.save();
            context.translate(x, y);
            context.rotate(rotation);
            context.fillStyle = '#333';
            context.fillText(char, 0, 0);
            context.restore();
        }
    
        // افزودن چند خط ساده برای پیچیدگی بیشتر
        context.strokeStyle = '#888';
        for (let i = 0; i < 3; i++) {
            context.beginPath();
            context.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
            context.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
            context.stroke();
        }
    }, []);
    

    const handleLogin = async (e) => {
        e.preventDefault();

        // بررسی تطابق عدد ورودی کاربر با عدد captcha
        if (userCaptchaInput !== captchaValue) {
            alert("کد امنیتی صحیح نیست.");
            return;
        }

        try {
            const response = await fetch('http://185.164.73.170:5001/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ password }), // ارسال رمز عبور به سرور
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setLogin(true);
            } else {
                alert('رمز عبور اشتباه است');
            }
        } catch (error) {
            console.error('Error during login:', error);
            alert('خطا در ارتباط با سرور');
        }
    };

    return (
        login ? <Panneladmin /> : (
            <div className='loginpage'>
                <div className='loginbox'>
                    <h2>ورود به پنل ادمین</h2>
                    <input type='password' placeholder='رمز وارد کنید' onChange={(e) => setPassword(e.target.value)} />
                    
                    {/* کادر کپچا */}
                    <canvas ref={captchaCanvasRef} width="100" height="50" className="captcha-canvas" />

                    {/* ورودی کاربر برای کد کپچا */}
                    <input 
                        type="text" 
                        placeholder="کد امنیتی را وارد کنید" 
                        value={userCaptchaInput} 
                        onChange={(e) => setUserCaptchaInput(e.target.value)}
                    />

                    {/* دکمه ورود */}
                    <button onClick={handleLogin}>ورود</button>
                </div>
            </div>
        )
    );
}
